import { LIMIT_KEY, SORT_KEY, VERSION_KEY, ARCHIVED_KEY, TEST_RIDE_KEY, EXTERNAL_ID_KEY, } from '@yme/common/constants';
import { Network } from '@yme/services/network';
export async function getProductsForTestRide({ endpoint, config: { sortOrder, limit, version, includeArchived, testRide, isExternalId }, }) {
    const params = {
        [SORT_KEY]: sortOrder,
        [LIMIT_KEY]: limit,
        [VERSION_KEY]: version,
        [ARCHIVED_KEY]: includeArchived,
        [TEST_RIDE_KEY]: testRide,
        [EXTERNAL_ID_KEY]: isExternalId,
    };
    const response = await Network.get(endpoint, {
        params,
    });
    return response.data;
}
